import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { ProviderTotalBalance } from '@kr/models';

import { getAccountMock } from '../../pages/account/mocks';
import { GetAccountRes } from '../../pages/account/models';
import { getTotalBalanceMock } from '../../pages/wallets/mocks';
import { ShellApiService } from '../api';

@Injectable()
export class ShellMockApi extends ShellApiService {
  override getAccount(): Observable<GetAccountRes> {
    const account = getAccountMock();

    return of(account).pipe(delay(500));
  }

  override getTotalBalance(): Observable<ProviderTotalBalance> {
    const totalBalance = getTotalBalanceMock();

    return of(totalBalance).pipe(delay(500));
  }
}
